import type { ReactNode } from "react";

type AlertTone = "info" | "warning" | "danger" | "success";

// Selbst-enthaltene Inline-Styles (keine CSS-Kopplung) — ersetzt die zuvor
// dupliziert per-Hand gebauten Hinweis-/Fehler-/ENTWURF-Boxen.
const TONE: Record<AlertTone, { bg: string; border: string; fg: string }> = {
  info: { bg: "#eff6ff", border: "#bfdbfe", fg: "#1e40af" },
  warning: { bg: "#fffbeb", border: "#fcd34d", fg: "#92400e" },
  danger: { bg: "#fee2e2", border: "#fca5a5", fg: "#b91c1c" },
  success: { bg: "#ecfdf5", border: "#a7f3d0", fg: "#047857" },
};

interface AlertProps {
  tone?: AlertTone;
  /** Optionale Hervorhebung am Zeilenanfang (z. B. "ENTWURF."). */
  title?: ReactNode;
  children: ReactNode;
}

/** Tonale Hinweisbox für leere/ladende/fehlerhafte Zustände und ENTWURF-Warnungen. */
export function Alert({ tone = "info", title, children }: AlertProps) {
  const t = TONE[tone];
  return (
    <div
      role={tone === "danger" ? "alert" : "status"}
      style={{
        background: t.bg,
        border: `1px solid ${t.border}`,
        borderRadius: 6,
        padding: "10px 14px",
        marginBottom: 16,
        fontSize: 13,
        color: t.fg,
      }}
    >
      {title && <strong style={{ marginRight: 6 }}>{title}</strong>}
      {children}
    </div>
  );
}
